import { useQuery } from 'react-query'
import { dashboardAPI } from '../utils/api'

export const useDashboard = (period = 'month') => {
  return useQuery(
    ['dashboard', period],
    () => dashboardAPI.getGlobal({ period }).then(res => res.data),
    {
      staleTime: 30 * 1000, // 30 seconds - more frequent refresh
      refetchOnWindowFocus: true,
      refetchInterval: 60 * 1000, // Auto-refresh every minute
    }
  )
}

export const useClientDashboard = (clientId, period = 'year') => {
  return useQuery(
    ['dashboard', 'client', clientId, period],
    () => dashboardAPI.getClient(clientId, { period }).then(res => res.data),
    {
      enabled: !!clientId,
      staleTime: 2 * 60 * 1000, // 2 minutes
    }
  )
}
